import { render } from "./DiagnosisRepairScan.vue?vue&type=template&id=174193cd&scoped=true&ts=true&lang=pug"
import script from "./DiagnosisRepairScan.vue?vue&type=script&lang=ts"
export * from "./DiagnosisRepairScan.vue?vue&type=script&lang=ts"

import "./DiagnosisRepairScan.vue?vue&type=style&index=0&id=174193cd&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-174193cd"]])

export default __exports__